export default {
  metaDescription: 'Hubungi PT Tokki Engineering and Fabrication (TEF). Kontak kantor kami di Cikarang, Cilegon, Gresik, dan Medan untuk penjualan dan pertanyaan.',
  pageTitle: 'Hubungi Kami',
  offices: {
    discovery: { label: 'Kantor & Pabrik Cikarang' },
    endeavor: { label: 'Kantor & Pabrik Cilegon' },
    voyager: { label: 'Kantor Cabang Gresik' },
    frontier: { label: 'Kantor Perwakilan Medan' },
  },
  salesTeam: {
    talkToOur: 'Bicara dengan',
    salesTeam: 'Tim Sales Kami',
    description: 'Silakan isi formulir di bawah ini. Tim kami yang tanggap akan segera mengirimkan pesan kepada Anda dan menjawab kebutuhan proyek Anda yang luar biasa.',
  },
  form: {
    name: 'Nama',
    companyName: 'Nama Perusahaan',
    email: 'Email',
    phoneNumber: 'Nomor Telepon',
    message: 'Pesan',
    send: 'Kirim',
    pleaseWait: 'Mohon Tunggu...',
  },
};
